import { START_BOT_CONVERSATION } from './adaptiveCardActionTypes';
import StartBotConversation from '../cardActions/StartBotConversation';
import { Action } from 'adaptivecards';
import { CardDetails } from 'owa-actionable-message-v2';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function processAutoInvokeAction(
    actionDefinition: any,
    cardDetails: CardDetails
): Action {
    if (isFeatureEnabled('mc-botConversation')) {
        if (actionDefinition.type === START_BOT_CONVERSATION) {
            const action = new StartBotConversation();
            action.parse(actionDefinition);
            return action;
        }
    }

    return null;
}
